import { Component } from '@angular/core';

import { DashboardStore } from '../dashboardv2.store';
import {
  DashboardTransactionsStore,
  transactionAnchorOptions,
  transactionStatusOptions,
} from '../stores/dashboard-transactions.store';

@Component({
  selector: 'app-dashboard-transactions',
  standalone: false,
  templateUrl: './dashboard-transactions.component.html',
  styleUrls: [
    '../dashboardv2.component.scss',
    './dashboard-transactions.component.scss',
  ],
  providers: [ DashboardTransactionsStore ],
})
export class DashboardTransactionsComponent {

  viewModel$ = this.transactionsStore.viewModel$;

  statusOptions = transactionStatusOptions;

  anchorOptions = transactionAnchorOptions;

  setStatus = this.transactionsStore.setStatus;

  setAnchor = this.transactionsStore.setAnchor;

  triggerReload = this.dashboardStore.triggerReload;

  constructor(
    private readonly dashboardStore: DashboardStore,
    private readonly transactionsStore: DashboardTransactionsStore,
  ) {}

}
